import React from "react";
import { ErrorState } from "./States";
import { reportBoundaryError } from "@/lib/observability/sentry";

interface Props {
  children: React.ReactNode;
  fallbackTitle?: string;
  fallbackMessage?: string;
  onReset?: () => void;
}
interface State { hasError: boolean; error: Error | null }

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info.componentStack);
    reportBoundaryError(error, { componentStack: info.componentStack });
  }
  reset = () => {
    this.setState({ hasError: false, error: null });
    this.props.onReset?.();
  };
  render() {
    if (this.state.hasError) {
      return (
        <ErrorState
          title={this.props.fallbackTitle || "Algo salió mal"}
          description={this.props.fallbackMessage || this.state.error?.message || "Intenta recargar la sección."}
          onRetry={this.reset}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;